import { createHttpClient } from '@adapters/HttpClient';
import { apiClientWH } from '@shared/services';
import { useInfiniteQuery } from '@tanstack/react-query';
import { OrdersApiAdapter } from '../adapters/OrdersApiAdapter';
import { Filters } from '../models/Filters';
import { Service } from '../services/Service';

export const useOrders = (filters: Filters = {}, options?: { enabled?: boolean }) => {
  const enabled = options?.enabled !== false;
  const httpClient = createHttpClient(apiClientWH);
  const apiAdapter = new OrdersApiAdapter(httpClient);
  const service = new Service(apiAdapter);

  const { data, isLoading, isFetching, error, refetch, fetchNextPage, hasNextPage, isFetchingNextPage, isPending } =
    useInfiniteQuery({
      queryKey: ['orders', filters],
      queryFn: ({ pageParam = 1 }) =>
        service.getPaginated({
          ...filters,
          page: pageParam,
        }),
      getNextPageParam: (lastPage) => lastPage.nextPage,
      initialPageParam: 1,
      staleTime: 2 * 60 * 1000, // 2 minutos
      // 🎯 En React Query v5, usamos placeholderData para mantener los datos anteriores
      placeholderData: (previousData) => previousData,
      enabled,
    });

  const orders = data?.pages.flatMap((page) => page.orders) ?? [];
  const totalFromApi = data?.pages?.[0]?.total ?? 0;

  return {
    orders,
    isLoading: isLoading || isPending,
    isFetching,
    error,
    refetch,
    fetchNextPage,
    hasNextPage: hasNextPage ?? false,
    isFetchingNextPage,
    totalPages: data?.pages.length ?? 0,
    totalLocations: orders.length,
    total: totalFromApi, // Total real del API (con filtros)
  };
};
